export const CHANGE_TABLE_SETTINGS = 'CHANGE_TABLE_SETTINGS';

export const changeTableSettings = (table, payload) => ({
    type: CHANGE_TABLE_SETTINGS,
    payload: {
        table,
        ...payload
    }
})
